import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { KRAKEN_OCTOPUS } from "@/components/PublicLayout";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-white gap-6" data-testid="auth-loading">
        <img src={KRAKEN_OCTOPUS} alt="Coastal Kraken" className="w-32 h-32 object-contain aqua-pulse drop-shadow-[0_0_30px_rgba(0,229,255,0.5)]" />
        <div className="font-display text-xl tracking-[0.4em] text-[#00E5FF]">LOADING</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}
